<template>
  <el-form
    :model="queryform"
    :rules="rules"
    ref="queryform"
    label-position="top"
  >
    <el-row>
      <!--      <el-col :span="12">-->
      <!--        <el-form-item label="接收配置标识" prop="r_config_defn">-->
      <!--          <el-input v-model="queryform.r_config_defn"></el-input>-->
      <!--        </el-form-item>-->
      <!--      </el-col>-->
      <el-col :span="12">
        <el-form-item label="发送身份编码(Senderid)" prop="r_sender_defn">
          <el-input v-model="queryform.r_sender_defn"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="报文类型" prop="s_msg_type">
          <el-input v-model="queryform.r_msg_type"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- 传输接收协议 -->
    <el-row style="display: flex;flex-wrap: wrap;">
      <el-col :span="12">
        <el-form-item
          label="传输接收协议"
          prop="r_receiver_conn_uuid"
          class="lablebtn"
        >
          <template slot="label">
            <span>传输接收协议</span>
            <el-button
              icon="el-icon-fa-asterisk"
              type="primary"
              class="pull-right"
              @click="csSelectSenior(queryform.r_receiver_conn_uuid)"
              title="高级选项"
              >高级</el-button
            >
          </template>
          <el-select
            v-model="queryform.r_receiver_conn_uuid"
            filterable
            clearable
            placeholder="请选择"
            @change="csSelectChange(queryform.r_receiver_conn_uuid)"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- csptdefn动态变化资源开始 -->
      <el-col :span="12" v-if="this.csptdefn === 'RocketMQ'">
        <el-form-item prop="recequeue" label="传输接收主题">
          <el-input v-model="queryform.recequeue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'RocketMQ'">
        <el-form-item prop="recetag" label="传输接收标签">
          <el-input v-model="queryform.recetag"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'RocketMQ'">
        <el-form-item prop="consumerGroup" label="传输接收组名">
          <el-input v-model="queryform.consumerGroup"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'RMQ'">
        <el-form-item prop="recequeue" label="传输接收队列">
          <el-input v-model="queryform.recequeue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'AMQ'">
        <el-form-item prop="recequeue" label="传输接收队列">
          <el-input v-model="queryform.recequeue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'WMQ'">
        <el-form-item prop="recequeue" label="传输接收队列">
          <el-input v-model="queryform.recequeue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'MSMQ'">
        <el-form-item prop="recequeue" label="传输接收队列">
          <el-input v-model="queryform.recequeue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'DIR'">
        <el-form-item prop="recedir" label="传输接收文件夹">
          <el-input v-model="queryform.recedir"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12" v-if="this.csptdefn === 'AS3'">
        <el-form-item prop="serverout" label="传输接收路径">
          <el-input v-model="queryform.csserverout"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'AS3'">
        <el-form-item prop="clientmdn" label="MDN回执路径">
          <el-input v-model="queryform.csclientmdn"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'AS3'">
        <el-form-item prop="clienttmp" label="临时路径">
          <el-input v-model="queryform.csclienttmp"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12" v-if="this.csptdefn === 'AS2'">
        <el-form-item prop="reqpath" label="访问地址">
          <el-input v-model="queryform.reqpath"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'AS2'">
        <el-form-item prop="port" label="端口">
          <el-input v-model="queryform.port"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'AS2'">
        <el-form-item prop="threshold" label="阈值">
          <el-input v-model="queryform.threshold"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12" v-if="this.csptdefn === 'FTP'">
        <el-form-item prop="recedir" label="传输接收文件夹">
          <el-input v-model="queryform.recedir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'FTPS'">
        <el-form-item prop="recedir" label="传输接收文件夹">
          <el-input v-model="queryform.recedir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'SFTP'">
        <el-form-item prop="recedir" label="传输接收文件夹">
          <el-input v-model="queryform.recedir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'SFTP'">
        <el-form-item prop="recedir" label="本地发送文件夹">
          <el-input v-model="queryform.recedir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'REST'">
        <el-form-item prop="port" label="端口">
          <el-input v-model="queryform.port"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'REST'">
        <el-form-item prop="reqpath" label="请求路径">
          <el-input v-model="queryform.reqpath"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.csptdefn === 'REST'">
        <el-form-item prop="cstoken" label="token">
          <el-input v-model="queryform.cstoken"></el-input>
        </el-form-item>
      </el-col>
      <!-- csptdefn动态变化资源结束 -->
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="责任链" prop="r_rc_uuid">
          <el-select
            v-model="queryform.r_rc_uuid"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in rpbOpt"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="路由" prop="r_cf_uuid">
          <el-select
            v-model="queryform.r_cf_uuid"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in routerOpt"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <!-- 本地接收协议 -->
    <el-row style="display: flex;flex-wrap: wrap;">
      <el-col :span="12">
        <el-form-item
          label="本地接收协议"
          prop="r_sender_conn_uuid"
          class="lablebtn"
        >
          <template slot="label">
            <span>本地接收协议</span>
            <el-button
              icon="el-icon-fa-asterisk"
              type="primary"
              class="pull-right"
              @click="pdSelectSenior(queryform.r_sender_conn_uuid)"
              title="高级选项"
              >高级</el-button
            >
          </template>
          <el-select
            v-model="queryform.r_sender_conn_uuid"
            clearable
            filterable
            placeholder="请选择"
            @change="pdSelectChange(queryform.r_sender_conn_uuid)"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- pdptdef动态变化资源开始 -->
      <el-col :span="12" v-if="this.pdptdefn === 'RocketMQ'">
        <el-form-item prop="producerGroup" label="本地接收组名">
          <el-input v-model="queryform.producerGroup"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'RocketMQ'">
        <el-form-item prop="sendtag" label="本地接收标签">
          <el-input v-model="queryform.sendtag"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'RocketMQ'">
        <el-form-item prop="sendqueue" label="本地接收主题">
          <el-input v-model="queryform.sendqueue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'RMQ'">
        <el-form-item prop="sendqueue" label="本地接收队列">
          <el-input v-model="queryform.sendqueue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'AMQ'">
        <el-form-item prop="sendqueue" label="本地接收队列">
          <el-input v-model="queryform.sendqueue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'WMQ'">
        <el-form-item prop="sendqueue" label="本地接收队列">
          <el-input v-model="queryform.sendqueue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'MSMQ'">
        <el-form-item prop="sendqueue" label="本地接收队列">
          <el-input v-model="queryform.sendqueue"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'DIR'">
        <el-form-item prop="senddir" label="本地接收文件夹">
          <el-input v-model="queryform.senddir"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12" v-if="this.pdptdefn === 'AS3'">
        <el-form-item prop="serverout" label="本地接收路径">
          <el-input v-model="queryform.pdserverout"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'AS3'">
        <el-form-item prop="clienttmp" label="临时路径">
          <el-input v-model="queryform.pdclienttmp"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'AS3'">
        <el-form-item prop="clientmdn" label="MDN回执路径">
          <el-input v-model="queryform.pdclientmdn"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12" v-if="this.pdptdefn === 'AS2'">
        <el-form-item prop="url" label="请求地址">
          <el-input v-model="queryform.url"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'AS2'">
        <el-form-item prop="as2from" label="消息来源ID">
          <el-input v-model="queryform.as2from"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'AS2'">
        <el-form-item prop="as2to" label="消息目标ID">
          <el-input v-model="queryform.as2to"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="12" v-if="this.pdptdefn === 'FTP'">
        <el-form-item prop="senddir" label="本地接收文件夹">
          <el-input v-model="queryform.senddir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'FTPS'">
        <el-form-item prop="senddir" label="本地接收文件夹">
          <el-input v-model="queryform.senddir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'SFTP'">
        <el-form-item prop="senddir" label="本地接收文件夹">
          <el-input v-model="queryform.senddir"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'REST'">
        <el-form-item prop="url" label="请求URL">
          <el-input v-model="queryform.url"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'REST'">
        <el-form-item prop="pdtoken" label="token">
          <el-input v-model="queryform.pdtoken"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" v-if="this.pdptdefn === 'REST'">
        <el-form-item prop="contenttype" label="请求类型">
          <el-input v-model="queryform.contenttype"></el-input>
        </el-form-item>
      </el-col>
      <!-- pdptdef动态变化资源结束 -->
    </el-row>
    <el-row>
      <el-collapse v-show="this.queryform.swap_uuid">
        <el-collapse-item>
          <template slot="title">
            性能调优（可选）
            <i class="header-icon el-icon-info"></i>
          </template>
          <template>
            <el-tabs type="border-card">
              <el-alert
                title="注意：性能调优在资源监听重新启动后生效"
                type="info"
                close-text="知道了"
                show-icon
              >
              </el-alert>
              <el-form :model="form" ref="form" label-position="top">
                <el-card class="box-card" title="发送调优">
                  <div slot="header" class="clearfix">
                    <span>性能调优</span>
                    <div class="pull-right">
                      <el-button
                        icon="el-icon-fa-save"
                        title="保存"
                        type="success"
                        plain
                        @click="saveThread()"
                        >保存</el-button
                      >
                    </div>
                  </div>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="消费者连接数" prop="receCsCnnum">
                        <el-input-number
                          v-model="form.receCsCnnum"
                          :min="1"
                          :max="99"
                          label="消费者连接数"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="生产者连接数" prop="recePdCnnum">
                        <el-input-number
                          v-model="form.recePdCnnum"
                          :min="1"
                          :max="99"
                          label="生产者连接数"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="发送处理线程数 " prop="receSpNum">
                        <el-input-number
                          v-model="form.receSpNum"
                          :min="1"
                          :max="99"
                          label="发送处理线程数"
                        ></el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
              </el-form>
            </el-tabs>
          </template>
        </el-collapse-item>
      </el-collapse>
    </el-row>

    <!--  RabbitMQ高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.rmqshow"
      title="RabbitMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="rmqCsResSave()"
          >保存</el-button
        >
      </div>
      <RabbitMQCsRes
        v-if="csSenior.rmqshow"
        ref="rmqcsres"
        :uuid="this.queryform.swap_uuid"
      ></RabbitMQCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.rmqshow"
      title="RabbitMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="rmqPdResSave()"
          >保存</el-button
        >
      </div>
      <RabbitMQPdRes
        v-if="pdSenior.rmqshow"
        ref="rmqpdres"
        :uuid="this.queryform.swap_uuid"
      ></RabbitMQPdRes>
    </el-dialog>
    <!--  AMQ高级配置  -->
    <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        :visible.sync="csSenior.amqshow"
        title="AMQ高级配置"
        width="600px"
        :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
            title="保存"
            class="blue"
            icon="el-icon-fa-save"
            @click="rmqCsResSave()"
        >保存</el-button
        >
      </div>
      <AMQCsRes
          v-if="csSenior.amqshow"
          ref="amqcsres"
          :uuid="this.queryform.swap_uuid"
      ></AMQCsRes>
    </el-dialog>
    <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        :visible.sync="pdSenior.amqshow"
        title="AMQ高级配置"
        width="600px"
        :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
            title="保存"
            class="blue"
            icon="el-icon-fa-save"
            @click="amqPdResSave()"
        >保存</el-button
        >
      </div>
      <AMQPdRes
          v-if="pdSenior.amqshow"
          ref="amqpdres"
          :uuid="this.queryform.swap_uuid"
      ></AMQPdRes>
    </el-dialog>
    <!--  IBMMQ高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.wmqshow"
      title="IBMMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="wmqCsResSave()"
          >保存</el-button
        >
      </div>
      <IBMMQCsRes
        v-if="csSenior.wmqshow"
        ref="wmqcsres"
        :uuid="this.queryform.swap_uuid"
      ></IBMMQCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.wmqshow"
      title="IBMMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="wmqPdResSave()"
          >保存</el-button
        >
      </div>
      <IBMMQPdRes
        v-if="pdSenior.wmqshow"
        ref="wmqpdres"
        :uuid="this.queryform.swap_uuid"
      ></IBMMQPdRes>
    </el-dialog>

    <!--  MSMQ高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.msmqshow"
      title="MSMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="msmqCsResSave()"
          >保存</el-button
        >
      </div>
      <MSMQCsRes
        v-if="csSenior.msmqshow"
        ref="msmqcsres"
        :uuid="this.queryform.swap_uuid"
      ></MSMQCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.msmqshow"
      title="MSMQ高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="msmqPdResSave()"
          >保存</el-button
        >
      </div>
      <MSMQPdRes
        v-if="pdSenior.msmqshow"
        ref="msmqpdres"
        :uuid="this.queryform.swap_uuid"
      ></MSMQPdRes>
    </el-dialog>

    <!--  DIR高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.dirshow"
      title="DIR高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="dirCsResSave()"
          >保存</el-button
        >
      </div>
      <DIRCsRes
        v-if="csSenior.dirshow"
        ref="dircsres"
        :uuid="this.queryform.swap_uuid"
      ></DIRCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.dirshow"
      title="DIR高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="dirPdResSave()"
          >保存</el-button
        >
      </div>
      <DIRPdRes
        v-if="pdSenior.dirshow"
        ref="dirpdres"
        :uuid="this.queryform.swap_uuid"
      ></DIRPdRes>
    </el-dialog>

    <!--  AS2高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.as2show"
      title="AS2高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="as2CsResSave()"
          >保存</el-button
        >
      </div>
      <AS2CsRes
        v-if="csSenior.as2show"
        ref="as2csres"
        :uuid="this.queryform.swap_uuid"
      ></AS2CsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.as2show"
      title="AS2高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="as2PdResSave()"
          >保存</el-button
        >
      </div>
      <AS2PdRes
        v-if="pdSenior.as2show"
        ref="as2pdres"
        :uuid="this.queryform.swap_uuid"
      ></AS2PdRes>
    </el-dialog>

    <!--  AS3高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.as3show"
      title="AS3高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="as3CsResSave()"
          >保存</el-button
        >
      </div>
      <AS3CsRes
        v-if="csSenior.as3show"
        ref="as3csres"
        :uuid="this.queryform.swap_uuid"
      ></AS3CsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.as3show"
      title="AS3高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="as3PdResSave()"
          >保存</el-button
        >
      </div>
      <AS3PdRes
        v-if="pdSenior.as3show"
        ref="as3pdres"
        :uuid="this.queryform.swap_uuid"
      ></AS3PdRes>
    </el-dialog>

    <!--  FTP高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.ftpshow"
      title="FTP高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="ftpCsResSave()"
          >保存</el-button
        >
      </div>
      <FTPCsRes
        v-if="csSenior.ftpshow"
        ref="ftpcsres"
        :uuid="this.queryform.swap_uuid"
      ></FTPCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.ftpshow"
      title="FTP高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="ftpPdResSave()"
          >保存</el-button
        >
      </div>
      <FTPPdRes
        v-if="pdSenior.ftpshow"
        ref="ftppdres"
        :uuid="this.queryform.swap_uuid"
      ></FTPPdRes>
    </el-dialog>

    <!--  FTPS高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.ftpsshow"
      title="FTPS高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="ftpsCsResSave()"
          >保存</el-button
        >
      </div>
      <FTPSCsRes
        v-if="csSenior.ftpsshow"
        ref="ftpscsres"
        :uuid="this.queryform.swap_uuid"
      ></FTPSCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.ftpsshow"
      title="FTPS高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="ftpsPdResSave()"
          >保存</el-button
        >
      </div>
      <FTPSPdRes
        v-if="pdSenior.ftpsshow"
        ref="ftpspdres"
        :uuid="this.queryform.swap_uuid"
      ></FTPSPdRes>
    </el-dialog>

    <!--  SFTP高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.sftpshow"
      title="SFTP高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="sftpCsResSave()"
          >保存</el-button
        >
      </div>
      <DIRCsRes
        v-if="csSenior.sftpshow"
        ref="sftpcsres"
        :uuid="this.queryform.swap_uuid"
      ></DIRCsRes>
    </el-dialog>
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="pdSenior.sftpshow"
      title="SFTP高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="sftpPdResSave()"
          >保存</el-button
        >
      </div>
      <DIRPdRes
        v-if="pdSenior.sftpshow"
        ref="sftppdres"
        :uuid="this.queryform.swap_uuid"
      ></DIRPdRes>
    </el-dialog>
    <!--  REST高级配置  -->
    <el-dialog
      close-on-press-escape
      append-to-body
      v-draggable
      :visible.sync="csSenior.restshow"
      title="REST高级配置"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
          title="保存"
          class="blue"
          icon="el-icon-fa-save"
          @click="restPdResSave()"
          >保存</el-button
        >
      </div>
      <RESTPdRes
        v-if="csSenior.restshow"
        ref="restpdres"
        :uuid="this.queryform.swap_uuid"
      ></RESTPdRes>
    </el-dialog>
    <!-- rocketMQ -->
    <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        :visible.sync="csSenior.rocketmq"
        title="RocketMQ高级配置"
        width="600px"
        :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
            title="保存"
            class="blue"
            icon="el-icon-fa-save"
            @click="restCsResSave()"
        >保存</el-button
        >
      </div>
      <RocketMQCsRes
          v-if="csSenior.rocketmq"
          ref="rocketcsres"
          :uuid="this.queryform.swap_uuid"
      ></RocketMQCsRes>
    </el-dialog>
    <el-dialog
        close-on-press-escape
        append-to-body
        v-draggable
        :visible.sync="pdSenior.rocketmq"
        title="RocketMQ高级配置"
        width="600px"
        :close-on-click-modal="false"
    >
      <div class="dialog-button">
        <el-button
            title="保存"
            class="blue"
            icon="el-icon-fa-save"
            @click="rocketPdResSave()"
        >保存</el-button
        >
      </div>
      <RocketMQPdRes
          v-if="pdSenior.rocketmq"
          ref="rocketpdres"
          :uuid="this.queryform.swap_uuid"
      ></RocketMQPdRes>
    </el-dialog>
  </el-form>
</template>
<style lang="scss">
.lablebtn {
  & .el-form-item__label {
    display: block;
    width: 100%;
    padding: 1px 3px;
  }
}
</style>
<script>
import idApi from '@/api/senior/idApi.js';
import seniorconf from '@/api/senior/seniorconf';
import rApi from '@/api/senior/seniorconf';
import RabbitMQCsRes from './component/RabbitMQCsRes';
import RabbitMQPdRes from './component/RabbitMQPdRes';
import AMQCsRes from "./component/AMQCsRes"
import IBMMQCsRes from './component/IBMMQCsRes';
import IBMMQPdRes from './component/IBMMQPdRes';
import MSMQCsRes from './component/MSMQCsRes';
import MSMQPdRes from './component/MSMQPdRes';
import DIRCsRes from './component/DIRCsRes';
import DIRPdRes from './component/DIRPdRes';
import AS2CsRes from './component/AS2CsRes';
import AS2PdRes from './component/AS2PdRes';
import AS3CsRes from './component/AS3CsRes';
import AS3PdRes from './component/AS3PdRes';
import FTPCsRes from './component/FTPCsRes';
import FTPPdRes from './component/FTPPdRes';
import FTPSCsRes from './component/FTPSCsRes';
import FTPSPdRes from './component/FTPSPdRes';
import SFTPCsRes from './component/SFTPCsRes';
import SFTPPdRes from './component/SFTPPdRes';
import RESTPdRes from './component/RESTPdRes';
import AMQPdRes from "./component/AMQPdRes";
import RocketMQCsRes from './component/RocketMQCsRes';
import RocketMQPdRes from './component/RocketMQPdRes';
let datafault = {
  ai_uuid: '',
  swap_uuid: '',
  r_config_defn: '',
  r_sender_defn: '',
  r_sender_conn_uuid: '',
  r_sender_res: '',
  r_rc_uuid: '',
  r_cs_cnnum: '',
  r_cf_uuid: '',
  r_cf_conf: '',
  r_receiver_conn_uuid: '',
  r_receiver_res: '',
  r_msg_type: '',
  r_charset: '',
  recequeue: '',
  sendqueue: '',
  sendtag:'',
  recetag:'',
  consumerGroup:'',
  producerGroup:'',
  recedir: '',
  senddir: '',
  csserverout: '',
  csclientmdn: '',
  csclienttmp: '',
  pdserverout: '',
  pdclienttmp: '',
  pdclientmdn: '',
  as2from: '',
  as2to: '',
  // REST
  cstoken: '',
  port: 20080,
  reqpath: '/rest/swap',
  ssl: false,
  threshold: 3000,
  maxsize: 4194304,
  url: '',
  pdtoken: '',
  contenttype: 'text/plain',
};
export default {
  name: 'IdReceConf',
  components: {
    RabbitMQCsRes,
    RabbitMQPdRes,
    IBMMQCsRes,
    IBMMQPdRes,
    MSMQCsRes,
    MSMQPdRes,
    DIRCsRes,
    DIRPdRes,
    AS2CsRes,
    AS2PdRes,
    AS3CsRes,
    AS3PdRes,
    FTPCsRes,
    FTPPdRes,
    SFTPCsRes,
    SFTPPdRes,
    FTPSCsRes,
    FTPSPdRes,
    idApi,
    RESTPdRes,
    AMQPdRes,
    AMQCsRes,
    RocketMQCsRes,
    RocketMQPdRes
  },
  props: {
    rece: '',
  },
  data() {
    return {
      form: {
        receCsCnnum: '',
        recePdCnnum: '',
        receSpNum: '',
      },
      queryform: Object.assign({}, datafault),
      options: Object,
      rpbOpt: Object,
      routerOpt: Object,
      model: {
        uuid: '',
        type: '',
      },
      modelcs: '',
      editor: {
        show: false,
      },
      recEdi: {
        show: false,
        info: '',
      },
      routerEdi: {
        show: false,
        info: '',
      },
      sendEdi: {
        show: false,
        info: '',
      },
      csptdefn: '',
      pdptdefn: '',
      csSenior: {
        wmqshow: false,
        rmqshow: false,
        amqshow: false,
        dirshow: false,
        msmqshow: false,
        ftpshow: false,
        ftpsshow: false,
        sftpshow: false,
        as2show: false,
        as3show: false,
        restshow: false,
        rocketmq:false,
        form: {},
      },
      pdSenior: {
        wmqshow: false,
        rmqshow: false,
        amqshow: false,
        dirshow: false,
        msmqshow: false,
        ftpshow: false,
        ftpsshow: false,
        sftpshow: false,
        as2show: false,
        as3show: false,
        restshow: false,
        rocketmq:false,
        form: {},
      },
      rules: {
        r_config_defn: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        r_sender_defn: [
          { required: true, message: '发送用户身份', trigger: 'blur' },
        ],
        r_receiver_conn_uuid: [
          { required: true, message: '传输接收协议', trigger: 'blur' },
        ],
        r_rc_uuid: [{ required: true, message: '责任链', trigger: 'blur' }],
        r_cs_cnnum: [{ required: true, message: '线程数', trigger: 'blur' }],
        r_sender_res: [
          { required: true, message: '本地接收资源', trigger: 'blur' },
        ],
        r_receiver_res: [
          { required: true, message: '传输接收配置', trigger: 'blur' },
        ],
        r_sender_conn_uuid: [
          { required: true, message: '本地接收协议', trigger: 'blur' },
        ],
        url: [{ required: true, message: '请求URL', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.queryform.ai_uuid = this.rece.uuid;
    idApi.selectPro().then((respData) => (this.options = respData.connList));
    idApi.selectRpb().then((respData) => (this.rpbOpt = respData.rpbChainList));
    idApi
      .selectRouter()
      .then((respData) => (this.routerOpt = respData.routerTypeList));
    if (this.rece.info) {
      idApi
        .InfoRece(this.rece.info.uuid, this.rece.ai_uuid)
        .then((respData) => {
          this.formatData(respData);
        });
    }
    this.queryThread();
  },
  methods: {
    model1() {
      this.modelcs = '';
      this.model.type = 'CS';
      this.model.uuid = this.queryform.r_receiver_conn_uuid;
      idApi
        .model(this.model.uuid, this.model.type)
        .then((respData) => (this.modelcs = respData.jsonMould));
      this.editor.show = true;
    },
    model2() {
      this.modelcs = '';
      this.model.type = 'PD';
      this.model.uuid = this.queryform.r_sender_conn_uuid;
      idApi
        .model(this.model.uuid, this.model.type)
        .then((respData) => (this.modelcs = respData.jsonMould));
      this.editor.show = true;
    },
    model3() {
      this.modelcs = '';
      this.model.type = '';
      this.model.uuid = this.queryform.r_cf_uuid;
      idApi
        .model(this.model.uuid, this.model.type)
        .then((respData) => (this.modelcs = respData.jsonMould));
      this.editor.show = true;
    },
    receConf() {
      this.recEdi.show = true;
      this.recEdi.info = this.queryform.r_receiver_res;
    },
    sendConf() {
      this.sendEdi.show = true;
      this.sendEdi.info = this.queryform.r_sender_res;
    },
    routerConf() {
      this.routerEdi.show = true;
      this.routerEdi.info = this.queryform.r_cf_conf;
    },
    saveConf1(val) {
      this.queryform.r_receiver_res = val;
      this.recEdi.show = false;
    },
    saveConf2(val) {
      this.queryform.r_sender_res = val;
      this.sendEdi.show = false;
    },
    saveConf3(val) {
      this.queryform.r_cf_conf = val;
      this.routerEdi.show = false;
    },
    saveReceConf() {
      this.$refs.queryform.validate((valid) => {
        if (valid) {
          this.setSenderRes();
          this.setRecverRes();
          if (this.rece.info) {
            idApi.editReceConf(this.queryform).then(() => {
              this.$emit('condRece');
            });
          } else {
            idApi.saveReceConf(this.queryform).then(() => {
              this.$emit('condRece');
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    formatData(val) {
      this.queryform.r_config_defn = val.datarows[0].rconfigdefn;
      this.queryform.r_sender_defn = val.datarows[0].rsenderdefn;
      this.queryform.r_receiver_conn_uuid = val.datarows[0].rreceiverconnuuid;
      this.queryform.r_receiver_res = val.datarows[0].rreceiverres;
      this.queryform.r_cf_uuid = val.datarows[0].rcfuuid;
      this.queryform.r_cf_conf = val.datarows[0].rcfconf;
      this.queryform.r_cs_cnnum = val.datarows[0].rcscnnum;
      this.queryform.r_msg_type = val.datarows[0].rmsgtype;
      this.queryform.r_sender_conn_uuid = val.datarows[0].rsenderconnuuid;
      this.queryform.r_sender_res = val.datarows[0].rsenderres;
      this.queryform.r_rc_uuid = val.datarows[0].rrcuuid;
      this.queryform.ai_uuid = this.rece.ai_uuid;
      this.queryform.swap_uuid = val.datarows[0].receswapuuid;
      this.csSelectChange(this.queryform.r_receiver_conn_uuid);
      this.pdSelectChange(this.queryform.r_sender_conn_uuid);
      this.getRecverRes(this.queryform.r_receiver_res);
      this.getSenderRes(this.queryform.r_sender_res);
    },
    queryThread() {
      seniorconf.queryThread(this.rece.info.receswapuuid).then((respData) => {
        this.form.receCsCnnum = respData.datas.cs_cnnum;
        this.form.recePdCnnum = respData.datas.pd_cnnum;
        this.form.receSpNum = respData.datas.sp_num;
      });
    },
    saveThread() {
      this.form.recespuuid = this.queryform.swap_uuid;
      rApi.saveThread(this.form).then(() => {
        this.queryThread();
      });
    },
    csSelectChange(uuid) {
      this.options.forEach((value) => {
        var _uuid = value.id;
        if (_uuid === uuid) {
          this.csptdefn = value.ptdefn;
        }
      });
    },
    pdSelectChange(uuid) {
      this.options.forEach((value) => {
        var _uuid = value.id;
        if (_uuid === uuid) {
          this.pdptdefn = value.ptdefn;
        }
      });
    },
    seniorinit() {
      this.csSenior.wmqshow = false;
      this.csSenior.rmqshow = false;
      this.csSenior.amqshow = false;
      this.csSenior.dirshow = false;
      this.csSenior.msmqshow = false;
      this.csSenior.ftpshow = false;
      this.csSenior.ftpsshow = false;
      this.csSenior.sftpshow = false;
      this.csSenior.as2show = false;
      this.csSenior.as3show = false;
      this.csSenior.restshow = false;
      this.pdSenior.wmqshow = false;
      this.pdSenior.rmqshow = false;
      this.pdSenior.amqshow = false;
      this.pdSenior.dirshow = false;
      this.pdSenior.msmqshow = false;
      this.pdSenior.ftpshow = false;
      this.pdSenior.ftpsshow = false;
      this.pdSenior.sftpshow = false;
      this.pdSenior.as2show = false;
      this.pdSenior.as3show = false;
      this.pdSenior.restshow = false;
    },
    // 消费者高级选项
    csSelectSenior(uuid) {
      if (this.csptdefn === '' || this.csptdefn === null) {
        this.$message.warning('请选择传输接收协议！');
        return;
      }
      this.seniorinit();
      if (this.csptdefn === 'RMQ') {
        this.csSenior.rmqshow = true;
      }else if (this.csptdefn === 'AMQ') {
        this.csSenior.amqshow = true;
      }
      else if (this.csptdefn === 'WMQ') {
        this.csSenior.wmqshow = true;
      } else if (this.csptdefn === 'DIR') {
        this.csSenior.dirshow = true;
      } else if (this.csptdefn === 'AS2') {
        this.csSenior.as2show = true;
      } else if (this.csptdefn === 'AS3') {
        this.csSenior.as3show = true;
      } else if (this.csptdefn === 'MSMQ') {
        this.csSenior.msmqshow = true;
      } else if (this.csptdefn === 'FTP') {
        this.csSenior.ftpshow = true;
      } else if (this.csptdefn === 'FTPS') {
        this.csSenior.ftpsshow = true;
      } else if (this.csptdefn === 'SFTP') {
        this.csSenior.sftpshow = true;
      } else if (this.csptdefn === 'REST') {
        this.csSenior.restshow = true;
      }
    },
    // 生产者高级选项
    pdSelectSenior(uuid) {
      if (this.pdptdefn === 'REST') return;
      if (this.pdptdefn === '' || this.pdptdefn === null) {
        this.$message.warning('请选择本地接收协议！');
        return;
      }
      this.seniorinit();
      if (this.pdptdefn === 'RMQ') {
        this.pdSenior.rmqshow = true;
      }
      else if (this.pdptdefn === 'AMQ') {
        this.pdSenior.amqshow = true;
      }
      else if (this.pdptdefn === 'WMQ') {
        this.pdSenior.wmqshow = true;
      } else if (this.pdptdefn === 'DIR') {
        this.pdSenior.dirshow = true;
      } else if (this.pdptdefn === 'AS2') {
        this.pdSenior.as2show = true;
      } else if (this.pdptdefn === 'AS3') {
        this.pdSenior.as3show = true;
      } else if (this.pdptdefn === 'MSMQ') {
        this.pdSenior.msmqshow = true;
      } else if (this.pdptdefn === 'FTP') {
        this.pdSenior.ftpshow = true;
      } else if (this.pdptdefn === 'FTPS') {
        this.pdSenior.ftpsshow = true;
      } else if (this.pdptdefn === 'SFTP') {
        this.pdSenior.sftpshow = true;
      } else if (this.pdptdefn === 'REST') {
        this.pdSenior.restshow = true;
      }
    },
    getRecverRes(conf) {
      var _form = JSON.parse(conf);
      if (this.csptdefn === 'RMQ') {
        this.queryform.recequeue = _form.recequeue;
      }
      else if (this.csptdefn === 'AMQ') {
        this.queryform.recequeue = _form.recequeue;
      }
      else if (this.csptdefn === 'WMQ') {
        this.queryform.recequeue = _form.recequeue;
      } else if (this.csptdefn === 'DIR') {
        this.queryform.recedir = _form.recedir;
      } else if (this.csptdefn === 'AS2') {
        this.queryform.reqpath = _form.reqpath;
        this.queryform.port = _form.port;
        this.queryform.threshold = _form.threshold;
      } else if (this.csptdefn === 'AS3') {
        this.queryform.csserverout = _form.csserverout;
        this.queryform.csclienttmp = _form.csclienttmp;
        this.queryform.csclientmdn = _form.csclientmdn;
      } else if (this.csptdefn === 'MSMQ') {
        this.queryform.recequeue = _form.recequeue;
      } else if (this.csptdefn === 'FTP') {
        this.queryform.recedir = _form.recedir;
      } else if (this.csptdefn === 'FTPS') {
        this.queryform.recedir = _form.recedir;
      } else if (this.csptdefn === 'SFTP') {
        this.queryform.recedir = _form.recedir;
      } else if (this.csptdefn === 'REST') {
        this.queryform.port = _form.port;
        this.queryform.reqpath = _form.reqpath;
        this.queryform.cstoken = _form.token;
      }else if (this.csptdefn === 'RocketMQ') {
        this.queryform.consumerGroup=_form.consumerGroup;
        this.queryform.recetag=_form.recetag;
        this.queryform.recequeue=_form.recequeue;
      }
    },
    // 赋值字段本地发送资源
    setRecverRes() {
      var _form = this.csSenior.form;
      if (this.csptdefn === 'RMQ') {
        _form.recequeue = this.queryform.recequeue;
      }
      else if (this.csptdefn === 'AMQ') {
        _form.recequeue = this.queryform.recequeue;
      }
      else if (this.csptdefn === 'WMQ') {
        _form.recequeue = this.queryform.recequeue;
      } else if (this.csptdefn === 'DIR') {
        _form.recedir = this.queryform.recedir;
      } else if (this.csptdefn === 'AS2') {
        _form.reqpath = this.queryform.reqpath;
        _form.port = this.queryform.port;
        _form.threshold = this.queryform.threshold;
      } else if (this.csptdefn === 'AS3') {
        _form.csserverout = this.queryform.csserverout;
        _form.csclienttmp = this.queryform.csclienttmp;
        _form.csclientmdn = this.queryform.csclientmdn;
      } else if (this.csptdefn === 'MSMQ') {
        _form.recequeue = this.queryform.recequeue;
      } else if (this.csptdefn === 'FTP') {
        _form.recedir = this.queryform.recedir;
      } else if (this.csptdefn === 'FTPS') {
        _form.recedir = this.queryform.recedir;
      } else if (this.csptdefn === 'SFTP') {
        _form.recedir = this.queryform.recedir;
      } else if (this.csptdefn === 'REST') {
        _form.port = this.queryform.port;
        _form.reqpath = this.queryform.reqpath;
        _form.token = this.queryform.cstoken;
      }else if (this.csptdefn === 'RocketMQ') {
        _form.consumerGroup = this.queryform.consumerGroup;
        _form.recetag = this.queryform.recetag;
        _form.recequeue = this.queryform.recequeue;
      }
      this.queryform.r_receiver_res = JSON.stringify(_form);
    },
    // 赋值字段传输发送资源
    setSenderRes() {
      var _form = this.pdSenior.form;
      if (this.pdptdefn === 'RMQ') {
        _form.sendqueue = this.queryform.sendqueue;
      }
      else if (this.pdptdefn === 'AMQ') {
        _form.sendqueue = this.queryform.sendqueue;
      }
      else if (this.pdptdefn === 'WMQ') {
        _form.sendqueue = this.queryform.sendqueue;
      } else if (this.pdptdefn === 'DIR') {
        _form.senddir = this.queryform.senddir;
      } else if (this.pdptdefn === 'AS2') {
        _form.url = this.queryform.url;
        _form.as2from = this.queryform.as2from;
        _form.as2to = this.queryform.as2to;
      } else if (this.pdptdefn === 'AS3') {
        _form.pdserverout = this.queryform.pdserverout;
        _form.pdclienttmp = this.queryform.pdclienttmp;
        _form.pdclientmdn = this.queryform.pdclientmdn;
      } else if (this.pdptdefn === 'MSMQ') {
        _form.sendqueue = this.queryform.sendqueue;
      } else if (this.pdptdefn === 'FTP') {
        _form.senddir = this.queryform.senddir;
      } else if (this.pdptdefn === 'FTPS') {
        _form.senddir = this.queryform.senddir;
      } else if (this.pdptdefn === 'SFTP') {
        _form.senddir = this.queryform.senddir;
      } else if (this.pdptdefn === 'RocketMQ') {
        _form.producerGroup = this.queryform.producerGroup;
        _form.sendtag = this.queryform.sendtag;
        _form.sendqueue = this.queryform.sendqueue;
      }
      this.queryform.r_sender_res = JSON.stringify(_form);
    },
    getSenderRes(conf) {
      var _form = JSON.parse(conf);
      if (this.pdptdefn === 'RMQ') {
        this.queryform.sendqueue = _form.sendqueue;
      }
      else if (this.pdptdefn === 'AMQ') {
        this.queryform.sendqueue = _form.sendqueue;
      }
      else if (this.pdptdefn === 'WMQ') {
        this.queryform.sendqueue = _form.sendqueue;
      } else if (this.pdptdefn === 'DIR') {
        this.queryform.senddir = _form.senddir;
      } else if (this.pdptdefn === 'AS2') {
        this.queryform.url = _form.url;
        this.queryform.as2from = _form.as2from;
        this.queryform.as2to = _form.as2to;
      } else if (this.pdptdefn === 'AS3') {
        this.queryform.pdserverout = _form.pdserverout;
        this.queryform.pdclienttmp = _form.pdclienttmp;
        this.queryform.pdclientmdn = _form.pdclientmdn;
      } else if (this.pdptdefn === 'MSMQ') {
        this.queryform.sendqueue = _form.sendqueue;
      } else if (this.pdptdefn === 'FTP') {
        this.queryform.senddir = _form.senddir;
      } else if (this.pdptdefn === 'FTPS') {
        this.queryform.senddir = _form.senddir;
      } else if (this.pdptdefn === 'SFTP') {
        this.queryform.senddir = _form.senddir;
      } else if (this.pdptdefn === 'REST') {
        this.queryform.pdtoken = _form.token;
        this.queryform.url = _form.url;
        this.queryform.contenttype = _form.contenttype;
      }else if (this.pdptdefn === 'RocketMQ') {
        this.queryform.producerGroup=_form.producerGroup;
        this.queryform.sendtag=_form.sendtag;
        this.queryform.sendqueue=_form.sendqueue;
      }
    },
    // rmq消费者保存
    rmqCsResSave() {
      this.csSenior.form = this.$refs.rmqcsres.save();
      this.seniorinit();
    },
    // rmq生产者保存
    rmqPdResSave() {
      this.pdSenior.form = this.$refs.rmqpdres.save();
      this.seniorinit();
    },
    // rmq消费者保存
    amqCsResSave() {
      this.csSenior.form = this.$refs.amqcsres.save();
      this.seniorinit();
    },
    // rmq生产者保存
    amqPdResSave() {
      this.pdSenior.form = this.$refs.amqpdres.save();
      this.seniorinit();
    },
    wmqCsResSave() {
      this.csSenior.form = this.$refs.wmqcsres.save();
      this.seniorinit();
    },
    wmqPdResSave() {
      this.csSenior.form = this.$refs.wmqpdres.save();
      this.seniorinit();
    },
    msmqCsResSave() {
      this.csSenior.form = this.$refs.msmqcsres.save();
      this.seniorinit();
    },
    msmqPdResSave() {
      this.csSenior.form = this.$refs.msmqpdres.save();
      this.seniorinit();
    },
    dirCsResSave() {
      this.csSenior.form = this.$refs.dircsres.save();
      this.seniorinit();
    },
    dirPdResSave() {
      this.csSenior.form = this.$refs.dirpdres.save();
      this.seniorinit();
    },
    as2CsResSave() {
      this.csSenior.form = this.$refs.as2csres.save();
      this.seniorinit();
    },
    as2PdResSave() {
      this.csSenior.form = this.$refs.as2pdres.save();
      this.seniorinit();
    },
    as3CsResSave() {
      this.csSenior.form = this.$refs.as3csres.save();
      this.seniorinit();
    },
    as3PdResSave() {
      this.csSenior.form = this.$refs.as3pdres.save();
      this.seniorinit();
    },
    ftpCsResSave() {
      this.csSenior.form = this.$refs.ftpcsres.save();
      this.seniorinit();
    },
    ftpPdResSave() {
      this.csSenior.form = this.$refs.ftppdres.save();
      this.seniorinit();
    },
    ftpsCsResSave() {
      this.csSenior.form = this.$refs.ftpscsres.save();
      this.seniorinit();
    },
    ftpsPdResSave() {
      this.csSenior.form = this.$refs.ftpspdres.save();
      this.seniorinit();
    },
    sftpCsResSave() {
      this.csSenior.form = this.$refs.sftpcsres.save();
      this.seniorinit();
    },
    sftpPdResSave() {
      this.csSenior.form = this.$refs.sftppdres.save();
      this.seniorinit();
    },
    restPdResSave() {
      this.csSenior.form = this.$refs.restpdres.save();
      this.seniorinit();
    },
    rocketCsResSave() {
      this.csSenior.form = this.$refs.rocketcsres.save();
      this.seniorinit();
    },
    rocketPdResSave(){
      this.csSenior.form = this.$refs.rocketpdres.save();
      this.seniorinit();
    },
  },
};
</script>
<style scoped>
.config-color {
  margin: 0px 10px 10px 10px;
  padding: 10px;
  background-color: #dbe2e8;
  border-radius: 4px;
}
</style>
